import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { States } from '../model/states';
// import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Districts } from '../model/districts'
// import * as dateFormat from 'dateformat';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
// import { MatStepper } from '@angular/material/stepper';



export interface tableColumns {
  name: string
  dataKey: string
  displayColumn: boolean
  sortDirection: '' | 'asc' | 'desc',
  filterKey: any,
  sticky?: 'start' | 'end' | 'none';
  static: boolean
}
//
@Component({
  selector: 'custom-table',
  templateUrl: './custom-table.component.html',
  styleUrls: ['./custom-table.component.scss']
})

export class CustomTableComponent implements OnInit {
  // ngAfterViewInit(): void {
  //   this.dtTrigger.next();
  // }

  // ngOnDestroy(): void {
  //   this.dtTrigger.unsubscribe();
  // }
  // dtOptions: DataTables.Settings = {
  //   pagingType: 'full_numbers',
  //   pageLength: 10,

  // };  
  // dtTrigger: Subject<any> = new Subject();
  // @ViewChild(DataTableDirective, { static: false })
  // dtElement!: DataTableDirective; 

  @Input() tableDatas: Array<any> = [];
  @Input() tableDatasOriginal: Array<any> = [];
  @Input() tableColumns: Array<tableColumns> = [];
  public stateFilter: string = "";
  public districtFilter: string = "";
  public stateFilterDatas!: Array<States>;
  public districtFilterDatas!: Array<Districts>;
  public loading: Boolean = false;
  public clinicTypeFilter: string = ""
  // public dropdownSettings!: IDropdownSettings;
  public dropdownListStates!: Array<any>;
  public dropdownListDistricts!: Array<any>;
  public dropdownListCircles!: Array<any>;
  public dropdownListEquipments!: Array<any>;


  public selectedState!: Array<any>;
  public selectedDistrict!: Array<any>;
  public selectedCircle!: Array<any>;
  public selectedEquipment!: Array<any>;
  public allDistricts!: Array<any>;


  public dateFrom: string = "";
  public dateTo: string = "";
  public date = new Date;
  public curDate: any
public dataTable2:any;
public assetTypes:any;
  page = 1
  pageSize = 10
  totalPageSize = 0

  toggleFilters: boolean = false

  constructor() {
    this.dataTable2 =[
      {beNumber : 'JHNANE001',beCategory : 'Analyzers, Laboratory, Hematology, Cell Counting, Automated (M)',beCndSts:'ACT',currentIno:'18 Yrs 5 Months 12 Days',pCost:'215000',sCost:'1183',spCost:'183',dDate:'21285',assetCategory : '',clinic_code:'JHR174',clinic_type:'PKD',age:'',manufacture:'',model:'Seca 3541317619',serial_no:'835E12',batch:'BATCH 7',variation_ord:''},
      {beNumber : 'JHNANE002',beCategory : 'Analyzers, Laboratory, Hematology, Cell Counting, Automated (M)',beCndSts:'ACT',currentIno:'48 Yrs 12 Month 14 Days',pCost:'24800',sCost:'136',spCost:'36',dDate:'6547.2',assetCategory : '',clinic_code:'JHR178',clinic_type:'PKD',age:'',manufacture:'',model:'Seca 3541317619',serial_no:'835E12',batch:'BATCH 7',variation_ord:''},
      {beNumber : 'JHNANE003',beCategory : 'Analyzers, Laboratory, Hematology, Cell Counting, Automated (M)',beCndSts:'ACT',currentIno:'48 Yrs 3 Month 13 Days',pCost:'24800',sCost:'136',spCost:'36',dDate:'6547.2',assetCategory : '',clinic_code:'JHR180',clinic_type:'PKD',age:'',manufacture:'',model:'Seca 3541317619',serial_no:'835E12',batch:'BATCH 7',variation_ord:''},
      {beNumber : 'JHNANE004',beCategory : 'ANALYZERS, LABORATORY, HEMATOLOGY, CELL COUNTING, AUTOMATED (M)',beCndSts:'ACT',currentIno:'48 Yrs 7 Month 22 Days',pCost:'24800',sCost:'136',spCost:'36',dDate:'6547.2',assetCategory : '',clinic_code:'JHR013',clinic_type:'PKD',age:'',manufacture:'',model:'SonoAce R3',serial_no:'S10MM3HJ300037L',batch:'BATCH 3',variation_ord:''},
      {beNumber : 'JHNANE005',beCategory : 'Analyzers, Laboratory, Hematology, Cell Counting, Automated (M)',beCndSts:'ACT',currentIno:'24 Yrs 2 Month 18 Days',pCost:'24800',sCost:'136',spCost:'36',dDate:'3273.6',assetCategory : '',clinic_code:'JHR020',clinic_type:'PKD',age:'',manufacture:'',model:'SonoAce R3',serial_no:'S10MM3HJ300035W',batch:'BATCH 3 ',variation_ord:''},
      {beNumber : 'JHNANE006',beCategory : 'Analyzers, Laboratory, Hematology, Cell Counting, Automated (M)',beCndSts:'ACT',currentIno:'48 Yrs 2 Month 18 Days',pCost:'24800',sCost:'136',spCost:'36',dDate:'6547.2',assetCategory : '',clinic_code:'JHR004',clinic_type:'PKD',age:'',manufacture:'',model:'VS 900 NIBP',serial_no:'FV-72015235',batch:'BATCH 3',variation_ord:''},
      {beNumber : 'JHNANE032',beCategory : 'Analyzers, Laboratory, Hematology, Cell Counting, Automated (M)',beCndSts:'ACT',currentIno:'48 Yrs 8 Month 7 Days',pCost:'24800',sCost:'136',spCost:'36',dDate:'6547.2',assetCategory : '',clinic_code:'JHR004',clinic_type:'PKD',age:'',manufacture:'',model:'VS 900 NIBP',serial_no:'FV-72015235',batch:'BATCH 3',variation_ord:''},
      {beNumber : 'JHNANE037',beCategory : 'ANALYZERS, LABORATORY, HEMATOLOGY, CELL COUNTING, AUTOMATED (M)',beCndSts:'ACT',currentIno:'50 Yrs 10 Month 30 Days',pCost:'24800',sCost:'136',spCost:'36',dDate:'6820 ',assetCategory : '',clinic_code:'JHR028',clinic_type:'PKD',age:'',manufacture:'',model:'SPIRO-S',serial_no:'M946800128877',batch:'BATCH 1',variation_ord:''},
      {beNumber : 'JHNANE038',beCategory : 'ANALYZERS, LABORATORY, HEMATOLOGY, CELL COUNTING, AUTOMATED (M)',beCndSts:'ACT',currentIno:'18 Yrs 2 Month 14 Days',pCost:'24800',sCost:'136',spCost:'36',dDate:'2455.2',assetCategory : '',clinic_code:'JHR029',clinic_type:'PKD',age:'',manufacture:'',model:'SPIRO-S',serial_no:'M946800128881',batch:'BATCH 1',variation_ord:''},
      {beNumber : 'JHNANE039',beCategory : 'ANALYZERS, LABORATORY, HEMATOLOGY, CELL COUNTING, AUTOMATED (M)',beCndSts:'ACT',currentIno:'18 Yrs 11 Month 29 Days',pCost:'24800',sCost:'136',spCost:'36',dDate:'2455.2',assetCategory : '',clinic_code:'JHR035',clinic_type:'PKD',age:'',manufacture:'',model:'SPIRO-S',serial_no:'NXGVYSM001925314F7600',batch:'Batch 12-SA7',variation_ord:''},
    ];
    this.assetTypes= [
      {
        id: 1,
        name: 'Radiology',
        date: '0',
        added : '820',
        removed : '4',
        endDate : '816'
      },
      {
        id: 2,
        name: 'Radiographic/Fluoroscopic Systems, General-Purpose',
        date: '0',
        added : '400',
        removed : '120',
        endDate : '400'
      },
      {
        id: 3,
        name: 'Analyzers, Automated (High)',
        date: '2',
        added : '120',
        removed : '2',
        endDate : '200'
      },
      {
        id: 4,
        name: 'Analyzers, Automated (Medium)',
        date: '5',
        added : '600',
        removed : '15',
        endDate : '300'
      },
      {
        id: 5,
        name: 'Hoods, Isolation, Laminar Air Flow',
        date: '1',
        added : '540',
        removed : '20',
        endDate : '100'
      },
      {
        id: 6,
        name: 'Chairs, Examination/ Treatment',
        date: '0',
        added : '400',
        removed : '250',
        endDate : '400'
      },
      // {
      //   id: 7,
      //   name: 'Chairs, Examination/ Treatment, Dentistry, Specialist',
      //   date: '2020/05/11',
      //   added : '0',
      //   removed : '',
      //   endDate : ''
      // },
      {
        id: 8,
        name: 'Dental Workstation',
        date: '7',
        added : '890',
        removed : '90',
        endDate : '200'
      },
      {
        id: 9,
        name: 'Fume Extractor',
        date: '2',
        added : '550',
        removed : '5',
        endDate : '400'
      },
    ];

  }
  active = 'Service Details'
  currentOrientation = 'vertical';
  dtOptions: DataTables.Settings = {

  };
//   goBack(stepper: MatStepper,event:any){
//     event.preventDefault();
//     stepper.previous();
// }

// goForward(stepper: MatStepper,event:any){
//     event.preventDefault();
//     stepper.next();
// }
  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers'
      };
    // this.dropdownSettings = {
    //   singleSelection: false,
    //   idField: 'item_id',
    //   textField: 'item_text',
    //   selectAllText: 'Select All',
    //   unSelectAllText: 'UnSelect All',
    //   itemsShowLimit: 3,
    //   allowSearchFilter: true
    // };
    this.dropdownListStates = [
      { item_id: 0, isActive: "Y", stateCode: "ALL", item_text: "ALL" },
      { item_id: 1, isActive: "Y", stateCode: "JHR", item_text: "JOHOR" },
      { item_id: 2, isActive: "Y", stateCode: "MLK", item_text: "MELAKA" },
      { item_id: 3, isActive: "Y", stateCode: "NSB", item_text: "NEGERI SEMBILAN" },
      { item_id: 4, isActive: "Y", stateCode: "PRK", item_text: "PERAK" },
      { item_id: 5, isActive: "Y", stateCode: "PNG", item_text: "PULAU PINANG" },
      { item_id: 6, isActive: "Y", stateCode: "PNGJ", item_text: "PULAU PINANG KOLEJ" },
      { item_id: 7, isActive: "Y", stateCode: "SBH", item_text: "SABAH" },
      { item_id: 8, isActive: "Y", stateCode: "SWK", item_text: "SARAWAK" },
      { item_id: 9, isActive: "Y", stateCode: "SLR", item_text: "SELANGOR" },
      { item_id: 10, isActive: "Y", stateCode: "WKL", item_text: "W.KUALA LUMPUR" },
      { item_id: 11, isActive: "Y", stateCode: "WPL", item_text: "LABUAN" }
    ];


    
    this.dropdownListEquipments = [
      { item_id: 1, isActive: "Y", stateCode: "JHR", item_text: "X Ray Film Processor" },
      { item_id: 2, isActive: "Y", stateCode: "MLK", item_text: "Autoclave Tabletop" },
      { item_id: 3, isActive: "Y", stateCode: "NSB", item_text: "Burner" },
      { item_id: 4, isActive: "Y", stateCode: "PRK", item_text: "Water Purifer" },
      // { item_id: 5, isActive: "Y", stateCode: "PNG", item_text: "PULAU PINANG" },
      // { item_id: 6, isActive: "Y", stateCode: "PNGJ", item_text: "PULAU PINANG KOLEJ" },
      // { item_id: 7, isActive: "Y", stateCode: "SBH", item_text: "SABAH" },
      // { item_id: 8, isActive: "Y", stateCode: "SWK", item_text: "SARAWAK" },
      // { item_id: 9, isActive: "Y", stateCode: "SLR", item_text: "SELANGOR" },
      // { item_id: 10, isActive: "Y", stateCode: "WKL", item_text: "W.KUALA LUMPUR" },
      // { item_id: 11, isActive: "Y", stateCode: "WPL", item_text: "LABUAN" }
    ];
    this.selectedState = [];

    this.selectedDistrict = [];
    this.selectedCircle = [];
    this.selectedEquipment = [];
    let listInvType: any = {}
    let tempInvType: any = []


    this.selectedDistrict.forEach((x, i) => {
      console.log(x, i)
      const num = x.item_id
      console.log(num)

      listInvType[`${num}`] = x.item_id;
      console.log(listInvType)
      tempInvType.push(listInvType[listInvType[`${num}`]])
      console.log(tempInvType)
    })


    this.tableColumns.forEach(col => {
      col.filterKey = ''
    })
    this.tableDatasOriginal = Array.from(this.tableDatas)
    this.totalPageSize = Math.ceil(this.tableDatasOriginal.length / this.pageSize)
  }
  onItemSelect(item: any) {
    console.log('x', item)


    this.dropdownListDistricts = []
    this.selectedState.forEach(x => {
      console.log(x, x.item_text)
      if (x.item_text == 'JOHOR') {
        let dropdownListDistricts
        dropdownListDistricts = [
          { item_id: 1, isActive: "Y", stateCode: "JHR", item_text: "BATU PAHAT" },
          { item_id: 2, isActive: "Y", stateCode: "MLK", item_text: "JOHOR BAHRU" },
          { item_id: 3, isActive: "Y", stateCode: "NSB", item_text: "KLUANG" },
          { item_id: 4, isActive: "Y", stateCode: "PRK", item_text: "KOTA TINGGI" },
          { item_id: 5, isActive: "Y", stateCode: "PNG", item_text: "KULAI JAYA" },
          { item_id: 6, isActive: "Y", stateCode: "PNGJ", item_text: "LEDANG" },
          { item_id: 7, isActive: "Y", stateCode: "SBH", item_text: "MERSING" },
          { item_id: 8, isActive: "Y", stateCode: "SWK", item_text: "MUAR" },
          { item_id: 9, isActive: "Y", stateCode: "SLR", item_text: "PONTIAN" },
          { item_id: 10, isActive: "Y", stateCode: "WKL", item_text: "SEGAMAT" },
        ]
        dropdownListDistricts.forEach(x => {
          this.dropdownListDistricts.push(x)
        });
      }
      else if (x.item_text == 'MELAKA') {
        let dropdownListDistricts = [
          { item_id: 11, isActive: "Y", stateCode: "WPL", item_text: "ALOR GAJAH" },
          { item_id: 12, isActive: "Y", stateCode: "ALL", item_text: "JASIN" },
          { item_id: 13, isActive: "Y", stateCode: "JHR", item_text: "MELAKA TENGAH" },
        ]
        dropdownListDistricts.forEach(x => {
          this.dropdownListDistricts.push(x)
        });
      }
      else if (x.item_text == 'NEGERI SEMBILAN') {
        let dropdownListDistricts = [
          { item_id: 14, isActive: "Y", stateCode: "MLK", item_text: "JELEBU" },
          { item_id: 15, isActive: "Y", stateCode: "NSB", item_text: "JEMPOL" },
          { item_id: 16, isActive: "Y", stateCode: "PRK", item_text: "KUALA PILAH" },
          { item_id: 17, isActive: "Y", stateCode: "PNG", item_text: "PORT DICKSON" },
          { item_id: 18, isActive: "Y", stateCode: "PNGJ", item_text: "REMBAU" },
          { item_id: 19, isActive: "Y", stateCode: "SBH", item_text: "SEREMBAN" },
          { item_id: 20, isActive: "Y", stateCode: "SWK", item_text: "TAMPIN" },
        ]
        dropdownListDistricts.forEach(x => {
          this.dropdownListDistricts.push(x)
        });
      }
      else if (x.item_text == 'PERAK') {
        let dropdownListDistricts = [
          { item_id: 21, isActive: "Y", stateCode: "SLR", item_text: "BATANG PADANG" },
          { item_id: 22, isActive: "Y", stateCode: "WKL", item_text: "HILIR PERAK" },
          { item_id: 23, isActive: "Y", stateCode: "WPL", item_text: "HULU PERAK" },
          { item_id: 24, isActive: "Y", stateCode: "ALL", item_text: "KAMPAR" },
          { item_id: 25, isActive: "Y", stateCode: "JHR", item_text: "KERIAN" },
          { item_id: 26, isActive: "Y", stateCode: "MLK", item_text: "KINTA" },
          { item_id: 27, isActive: "Y", stateCode: "NSB", item_text: "KUALA KANGSAR" },
          { item_id: 28, isActive: "Y", stateCode: "PRK", item_text: "LARUT MATANG SELAMA" },
          { item_id: 29, isActive: "Y", stateCode: "PNG", item_text: "MANJUNG" },
          { item_id: 30, isActive: "Y", stateCode: "PNGJ", item_text: "MUALLIM" },
          { item_id: 31, isActive: "Y", stateCode: "SBH", item_text: "PERAK TENGAH" },
        ]
        dropdownListDistricts.forEach(x => {
          this.dropdownListDistricts.push(x)
        });
      }
      else if (x.item_text == 'PULAU PINANG') {
        let dropdownListDistricts = [
          { item_id: 32, isActive: "Y", stateCode: "SWK", item_text: "BARAT DAYA" },
          { item_id: 33, isActive: "Y", stateCode: "SLR", item_text: "SEBERANG PERAI SELATAN" },
          { item_id: 34, isActive: "Y", stateCode: "WKL", item_text: "SEBERANG PERAI TENGAH" },
          { item_id: 35, isActive: "Y", stateCode: "WPL", item_text: "SEBERANG PERAI UTARA" },
          { item_id: 36, isActive: "Y", stateCode: "ALL", item_text: "TIMUR LAUT" },
        ]
        dropdownListDistricts.forEach(x => {
          this.dropdownListDistricts.push(x)
        });
      }
      else if (x.item_text == 'PULAU PINANG KOLEJ') {
        let dropdownListDistricts = [
          { item_id: 37, isActive: "Y", stateCode: "JHR", item_text: "PULAU PINANG KOLEJ" },

        ]
        dropdownListDistricts.forEach(x => {
          this.dropdownListDistricts.push(x)
        });
      }
      else if (x.item_text == 'SABAH') {
        let dropdownListDistricts = [
          { item_id: 38, isActive: "Y", stateCode: "MLK", item_text: "BEAUFORT" },
          { item_id: 39, isActive: "Y", stateCode: "NSB", item_text: "BELURAN" },
          { item_id: 40, isActive: "Y", stateCode: "PRK", item_text: "KENINGAU" },
          { item_id: 41, isActive: "Y", stateCode: "PNG", item_text: "KINABATANGAN" },
          { item_id: 42, isActive: "Y", stateCode: "PNGJ", item_text: "KOTA BELUD" },
          { item_id: 43, isActive: "Y", stateCode: "SBH", item_text: "KOTA KINABALU" },
          { item_id: 44, isActive: "Y", stateCode: "SWK", item_text: "KOTA MARUDU" },
          { item_id: 45, isActive: "Y", stateCode: "SLR", item_text: "KUALA PENYU" },
          { item_id: 46, isActive: "Y", stateCode: "WKL", item_text: "KUDAT" },
          { item_id: 47, isActive: "Y", stateCode: "WPL", item_text: "KUNAK" },
          { item_id: 48, isActive: "Y", stateCode: "ALL", item_text: "LAHAD DATU" },
          { item_id: 49, isActive: "Y", stateCode: "JHR", item_text: "NABAWAN" },
          { item_id: 50, isActive: "Y", stateCode: "MLK", item_text: "PAPAR" },
          { item_id: 51, isActive: "Y", stateCode: "NSB", item_text: "PENAMPANG" },
          { item_id: 52, isActive: "Y", stateCode: "PRK", item_text: "PITAS" },
          { item_id: 53, isActive: "Y", stateCode: "PNG", item_text: "RANAU" },
          { item_id: 54, isActive: "Y", stateCode: "PNGJ", item_text: "SANDAKAN" },
          { item_id: 55, isActive: "Y", stateCode: "SBH", item_text: "SEMPORNA" },
          { item_id: 56, isActive: "Y", stateCode: "SWK", item_text: "SIPITANG" },
          { item_id: 57, isActive: "Y", stateCode: "SLR", item_text: "TAMBUNAN" },
          { item_id: 58, isActive: "Y", stateCode: "WKL", item_text: "TAWAU" },
          { item_id: 59, isActive: "Y", stateCode: "WPL", item_text: "TENOM" },
          { item_id: 60, isActive: "Y", stateCode: "ALL", item_text: "TONGOD" },
          { item_id: 61, isActive: "Y", stateCode: "JHR", item_text: "TUARAN" },
        ]
        dropdownListDistricts.forEach(x => {
          this.dropdownListDistricts.push(x)
        });
      }
      else if (x.item_text == 'SARAWAK') {
        let dropdownListDistricts = [
          { item_id: 62, isActive: "Y", stateCode: "MLK", item_text: "BETONG" },
          { item_id: 63, isActive: "Y", stateCode: "NSB", item_text: "BINTULU" },
          { item_id: 64, isActive: "Y", stateCode: "PRK", item_text: "KAPIT" },
          { item_id: 65, isActive: "Y", stateCode: "PNG", item_text: "KUCHING" },
          { item_id: 66, isActive: "Y", stateCode: "PNGJ", item_text: "LIMBANG" },
          { item_id: 67, isActive: "Y", stateCode: "SBH", item_text: "MIRI" },
          { item_id: 68, isActive: "Y", stateCode: "SWK", item_text: "MUKAH" },
          { item_id: 69, isActive: "Y", stateCode: "SLR", item_text: "SAMARAHAN" },
          { item_id: 70, isActive: "Y", stateCode: "WKL", item_text: "SARIKEI" },
          { item_id: 71, isActive: "Y", stateCode: "WPL", item_text: "SERIAN" },
          { item_id: 72, isActive: "Y", stateCode: "ALL", item_text: "SIBU" },
          { item_id: 73, isActive: "Y", stateCode: "JHR", item_text: "SRI AMAN" },
        ]
        dropdownListDistricts.forEach(x => {
          this.dropdownListDistricts.push(x)
        });
      }
      else if (x.item_text == 'SELANGOR') {
        let dropdownListDistricts = [
          { item_id: 74, isActive: "Y", stateCode: "MLK", item_text: "GOMBAK" },
          { item_id: 75, isActive: "Y", stateCode: "NSB", item_text: "HULU LANGAT" },
          { item_id: 76, isActive: "Y", stateCode: "PRK", item_text: "HULU SELANGOR" },
          { item_id: 77, isActive: "Y", stateCode: "PNG", item_text: "KLANG" },
          { item_id: 78, isActive: "Y", stateCode: "PNGJ", item_text: "KUALA LANGAT" },
          { item_id: 79, isActive: "Y", stateCode: "SBH", item_text: "KUALA SELANGOR" },
          { item_id: 80, isActive: "Y", stateCode: "SWK", item_text: "PETALING" },
          { item_id: 81, isActive: "Y", stateCode: "SLR", item_text: "SABAK BERNAM" },
          { item_id: 82, isActive: "Y", stateCode: "WKL", item_text: "SEPANG" },
        ]
        dropdownListDistricts.forEach(x => {
          this.dropdownListDistricts.push(x)
        });
      }
      else if (x.item_text == 'W.KUALA LUMPUR') {
        let dropdownListDistricts = [
          { item_id: 83, isActive: "Y", stateCode: "WPL", item_text: "CHERAS" },
          { item_id: 84, isActive: "Y", stateCode: "ALL", item_text: "KEPONG" },
          { item_id: 85, isActive: "Y", stateCode: "JHR", item_text: "LEMBAH PANTAI" },
          { item_id: 86, isActive: "Y", stateCode: "MLK", item_text: "PUTRAJAYA" },
          { item_id: 87, isActive: "Y", stateCode: "NSB", item_text: "TITIWANGSA" },
        ]
        dropdownListDistricts.forEach(x => {
          this.dropdownListDistricts.push(x)
        });
      }
      else if (x.item_text == 'LABUAN') {
        let dropdownListDistricts = [
          { item_id: 88, isActive: "Y", stateCode: "PRK", item_text: "LABUAN" },

        ]
        dropdownListDistricts.forEach(x => {
          this.dropdownListDistricts.push(x)
        });
      }
      else {
        this.dropdownListDistricts = [
          { item_id: 0, isActive: "Y", stateCode: "ALL", item_text: "ALL" },

        ]
      }
    });
this.dropdownListCircles=[]
    this.selectedState.forEach(x => {
      if (x.item_text == 'JOHOR') {
        let dropdownListCircles = [
          { item_id: 1, isActive: "Y", stateCode: "JHR", item_text: "SC1" },
          { item_id: 2, isActive: "Y", stateCode: "MLK", item_text: "SC2" },
          { item_id: 3, isActive: "Y", stateCode: "ALL", item_text: "SC3" },
          { item_id: 28, isActive: "Y", stateCode: "ALL", item_text: "SC7" }

        ]
        dropdownListCircles.forEach(x => {
          this.dropdownListCircles.push(x)
        })
      }

      else if (x.item_text == 'MELAKA') {
        let dropdownListCircles = [
          { item_id: 4, isActive: "Y", stateCode: "JHR", item_text: "SC4" },


        ]
        dropdownListCircles.forEach(x => {
          this.dropdownListCircles.push(x)
        })
      }
      else if (x.item_text == 'NEGERI SEMBILAN') {
        let dropdownListCircles = [
          { item_id: 5, isActive: "Y", stateCode: "MLK", item_text: "SC5" },
          { item_id: 6, isActive: "Y", stateCode: "ALL", item_text: "SC6" },

        ]
        dropdownListCircles.forEach(x => {
          this.dropdownListCircles.push(x)
        })
      }
      else if (x.item_text == 'PERAK') {
        let dropdownListCircles = [
          { item_id: 7, isActive: "Y", stateCode: "JHR", item_text: "NC1" },
          { item_id: 8, isActive: "Y", stateCode: "MLK", item_text: "NC2" },
          { item_id: 9, isActive: "Y", stateCode: "ALL", item_text: "NC3" },

        ]
        dropdownListCircles.forEach(x => {
          this.dropdownListCircles.push(x)
        })
      }
      else if (x.item_text == 'PULAU PINANG') {
        let dropdownListCircles = [
          { item_id: 10, isActive: "Y", stateCode: "JHR", item_text: "NC4" },
          { item_id: 11, isActive: "Y", stateCode: "MLK", item_text: "NC5" },

        ]
        dropdownListCircles.forEach(x => {
          this.dropdownListCircles.push(x)
        })
      }
      else if (x.item_text == 'PULAU PINANG KOLEJ') {
        let dropdownListCircles = [
          { item_id: 12, isActive: "Y", stateCode: "ALL", item_text: "NC6" },


        ]
        dropdownListCircles.forEach(x => {
          this.dropdownListCircles.push(x)
        })
      }
      else if (x.item_text == 'SABAH') {
        let dropdownListCircles = [
          { item_id: 13, isActive: "Y", stateCode: "JHR", item_text: "EMC1" },
          { item_id: 14, isActive: "Y", stateCode: "MLK", item_text: "EMC2" },
          { item_id: 15, isActive: "Y", stateCode: "ALL", item_text: "EMC3" },
          { item_id: 16, isActive: "Y", stateCode: "JHR", item_text: "EMC4" },
          { item_id: 17, isActive: "Y", stateCode: "MLK", item_text: "EMC5" },

        ]
        dropdownListCircles.forEach(x => {
          this.dropdownListCircles.push(x)
        })
      }
      else if (x.item_text == 'SARAWAK') {
        let dropdownListCircles = [
          { item_id: 18, isActive: "Y", stateCode: "ALL", item_text: "EMC6" },
          { item_id: 19, isActive: "Y", stateCode: "JHR", item_text: "EMC7" },
          { item_id: 20, isActive: "Y", stateCode: "MLK", item_text: "EMC8" },
          { item_id: 21, isActive: "Y", stateCode: "MLK", item_text: "EMC9" },

        ]
        dropdownListCircles.forEach(x => {
          this.dropdownListCircles.push(x)
        })
      }
      else if (x.item_text == 'SELANGOR') {
        let dropdownListCircles = [
          { item_id: 22, isActive: "Y", stateCode: "ALL", item_text: "CC1" },
          { item_id: 23, isActive: "Y", stateCode: "JHR", item_text: "CC2" },
          { item_id: 24, isActive: "Y", stateCode: "MLK", item_text: "CC3" },
          { item_id: 25, isActive: "Y", stateCode: "ALL", item_text: "CC4" },

        ]
        dropdownListCircles.forEach(x => {
          this.dropdownListCircles.push(x)
        })
      }
      else if (x.item_text == 'W.KUALA LUMPUR') {
        let dropdownListCircles = [
          { item_id: 26, isActive: "Y", stateCode: "JHR", item_text: "CC5" },
          { item_id: 27, isActive: "Y", stateCode: "MLK", item_text: "CC6" },

        ]
        dropdownListCircles.forEach(x => {
          this.dropdownListCircles.push(x)
        })
      }
      else if (x.item_text == 'LABUAN') {
        let dropdownListCircles = [
          { item_id: 13, isActive: "Y", stateCode: "JHR", item_text: "EMC1" },


        ]
        dropdownListCircles.forEach(x => {
          this.dropdownListCircles.push(x)
        })
      }
      else {
        this.dropdownListCircles = [
          { item_id: 0, isActive: "Y", stateCode: "ALL", item_text: "ALL" }
        ]

      }



    })

    // this.dropdownListCircles = [
    //   { item_id: 0, isActive: "Y", stateCode: "ALL", item_text: "ALL" },
    //   { item_id: 1, isActive: "Y", stateCode: "JHR", item_text: "SC1" },
    //   { item_id: 2, isActive: "Y", stateCode: "MLK", item_text: "SC2" },
    //   { item_id: 3, isActive: "Y", stateCode: "ALL", item_text: "SC3" },
    //   { item_id: 4, isActive: "Y", stateCode: "JHR", item_text: "SC4" },
    //   { item_id: 5, isActive: "Y", stateCode: "MLK", item_text: "SC5" },
    //   { item_id: 6, isActive: "Y", stateCode: "ALL", item_text: "SC6" },
    //   { item_id: 7, isActive: "Y", stateCode: "JHR", item_text: "NC1" },
    //   { item_id: 8, isActive: "Y", stateCode: "MLK", item_text: "NC2" },
    //   { item_id: 9, isActive: "Y", stateCode: "ALL", item_text: "NC3" },
    //   { item_id: 10, isActive: "Y", stateCode: "JHR", item_text: "NC4" },
    //   { item_id: 11, isActive: "Y", stateCode: "MLK", item_text: "NC5" },
    //   { item_id: 12, isActive: "Y", stateCode: "ALL", item_text: "NC6" },
    //   { item_id: 13, isActive: "Y", stateCode: "JHR", item_text: "EMC1" },
    //   { item_id: 14, isActive: "Y", stateCode: "MLK", item_text: "EMC2" },
    //   { item_id: 15, isActive: "Y", stateCode: "ALL", item_text: "EMC3" },
    //   { item_id: 16, isActive: "Y", stateCode: "JHR", item_text: "EMC4" },
    //   { item_id: 17, isActive: "Y", stateCode: "MLK", item_text: "EMC5" },
    //   { item_id: 18, isActive: "Y", stateCode: "ALL", item_text: "EMC6" },
    //   { item_id: 19, isActive: "Y", stateCode: "JHR", item_text: "EMC7" },
    //   { item_id: 20, isActive: "Y", stateCode: "MLK", item_text: "EMC8" },
    //   { item_id: 21, isActive: "Y", stateCode: "MLK", item_text: "EMC9" },
    //   { item_id: 22, isActive: "Y", stateCode: "ALL", item_text: "CC1" },
    //   { item_id: 23, isActive: "Y", stateCode: "JHR", item_text: "CC2" },
    //   { item_id: 24, isActive: "Y", stateCode: "MLK", item_text: "CC3" },
    //   { item_id: 25, isActive: "Y", stateCode: "ALL", item_text: "CC4" },
    //   { item_id: 26, isActive: "Y", stateCode: "JHR", item_text: "CC5" },
    //   { item_id: 27, isActive: "Y", stateCode: "MLK", item_text: "CC6" },
    //   { item_id: 28, isActive: "Y", stateCode: "ALL", item_text: "SC7" }
    // ]
  }
  onSelectAll(items: any) {
    console.log(items)
    this.selectedState.forEach(x => {
      if (x.item_id = 'ALL') {


        this.dropdownListDistricts = [

          { item_id: 1, isActive: "Y", stateCode: "JHR", item_text: "BATU PAHAT" },
          { item_id: 2, isActive: "Y", stateCode: "MLK", item_text: "JOHOR BAHRU" },
          { item_id: 3, isActive: "Y", stateCode: "NSB", item_text: "KLUANG" },
          { item_id: 4, isActive: "Y", stateCode: "PRK", item_text: "KOTA TINGGI" },
          { item_id: 5, isActive: "Y", stateCode: "PNG", item_text: "KULAI JAYA" },
          { item_id: 6, isActive: "Y", stateCode: "PNGJ", item_text: "LEDANG" },
          { item_id: 7, isActive: "Y", stateCode: "SBH", item_text: "MERSING" },
          { item_id: 8, isActive: "Y", stateCode: "SWK", item_text: "MUAR" },
          { item_id: 9, isActive: "Y", stateCode: "SLR", item_text: "PONTIAN" },
          { item_id: 10, isActive: "Y", stateCode: "WKL", item_text: "SEGAMAT" },
          { item_id: 11, isActive: "Y", stateCode: "WPL", item_text: "ALOR GAJAH" },
          { item_id: 12, isActive: "Y", stateCode: "ALL", item_text: "JASIN" },
          { item_id: 13, isActive: "Y", stateCode: "JHR", item_text: "MELAKA TENGAH" },
          { item_id: 14, isActive: "Y", stateCode: "MLK", item_text: "JELEBU" },
          { item_id: 15, isActive: "Y", stateCode: "NSB", item_text: "JEMPOL" },
          { item_id: 16, isActive: "Y", stateCode: "PRK", item_text: "KUALA PILAH" },
          { item_id: 17, isActive: "Y", stateCode: "PNG", item_text: "PORT DICKSON" },
          { item_id: 18, isActive: "Y", stateCode: "PNGJ", item_text: "REMBAU" },
          { item_id: 19, isActive: "Y", stateCode: "SBH", item_text: "SEREMBAN" },
          { item_id: 20, isActive: "Y", stateCode: "SWK", item_text: "TAMPIN" },
          { item_id: 21, isActive: "Y", stateCode: "SLR", item_text: "BATANG PADANG" },
          { item_id: 22, isActive: "Y", stateCode: "WKL", item_text: "HILIR PERAK" },
          { item_id: 23, isActive: "Y", stateCode: "WPL", item_text: "HULU PERAK" },
          { item_id: 24, isActive: "Y", stateCode: "ALL", item_text: "KAMPAR" },
          { item_id: 25, isActive: "Y", stateCode: "JHR", item_text: "KERIAN" },
          { item_id: 26, isActive: "Y", stateCode: "MLK", item_text: "KINTA" },
          { item_id: 27, isActive: "Y", stateCode: "NSB", item_text: "KUALA KANGSAR" },
          { item_id: 28, isActive: "Y", stateCode: "PRK", item_text: "LARUT MATANG SELAMA" },
          { item_id: 29, isActive: "Y", stateCode: "PNG", item_text: "MANJUNG" },
          { item_id: 30, isActive: "Y", stateCode: "PNGJ", item_text: "MUALLIM" },
          { item_id: 31, isActive: "Y", stateCode: "SBH", item_text: "PERAK TENGAH" },

          { item_id: 32, isActive: "Y", stateCode: "SWK", item_text: "BARAT DAYA" },
          { item_id: 33, isActive: "Y", stateCode: "SLR", item_text: "SEBERANG PERAI SELATAN" },
          { item_id: 34, isActive: "Y", stateCode: "WKL", item_text: "SEBERANG PERAI TENGAH" },
          { item_id: 35, isActive: "Y", stateCode: "WPL", item_text: "SEBERANG PERAI UTARA" },
          { item_id: 36, isActive: "Y", stateCode: "ALL", item_text: "TIMUR LAUT" },

          { item_id: 37, isActive: "Y", stateCode: "JHR", item_text: "PULAU PINANG KOLEJ" },

          { item_id: 38, isActive: "Y", stateCode: "MLK", item_text: "BEAUFORT" },
          { item_id: 39, isActive: "Y", stateCode: "NSB", item_text: "BELURAN" },
          { item_id: 40, isActive: "Y", stateCode: "PRK", item_text: "KENINGAU" },
          { item_id: 41, isActive: "Y", stateCode: "PNG", item_text: "KINABATANGAN" },
          { item_id: 42, isActive: "Y", stateCode: "PNGJ", item_text: "KOTA BELUD" },
          { item_id: 43, isActive: "Y", stateCode: "SBH", item_text: "KOTA KINABALU" },
          { item_id: 44, isActive: "Y", stateCode: "SWK", item_text: "KOTA MARUDU" },
          { item_id: 45, isActive: "Y", stateCode: "SLR", item_text: "KUALA PENYU" },
          { item_id: 46, isActive: "Y", stateCode: "WKL", item_text: "KUDAT" },
          { item_id: 47, isActive: "Y", stateCode: "WPL", item_text: "KUNAK" },
          { item_id: 48, isActive: "Y", stateCode: "ALL", item_text: "LAHAD DATU" },
          { item_id: 49, isActive: "Y", stateCode: "JHR", item_text: "NABAWAN" },
          { item_id: 50, isActive: "Y", stateCode: "MLK", item_text: "PAPAR" },
          { item_id: 51, isActive: "Y", stateCode: "NSB", item_text: "PENAMPANG" },
          { item_id: 52, isActive: "Y", stateCode: "PRK", item_text: "PITAS" },
          { item_id: 53, isActive: "Y", stateCode: "PNG", item_text: "RANAU" },
          { item_id: 54, isActive: "Y", stateCode: "PNGJ", item_text: "SANDAKAN" },
          { item_id: 55, isActive: "Y", stateCode: "SBH", item_text: "SEMPORNA" },
          { item_id: 56, isActive: "Y", stateCode: "SWK", item_text: "SIPITANG" },
          { item_id: 57, isActive: "Y", stateCode: "SLR", item_text: "TAMBUNAN" },
          { item_id: 58, isActive: "Y", stateCode: "WKL", item_text: "TAWAU" },
          { item_id: 59, isActive: "Y", stateCode: "WPL", item_text: "TENOM" },
          { item_id: 60, isActive: "Y", stateCode: "ALL", item_text: "TONGOD" },
          { item_id: 61, isActive: "Y", stateCode: "JHR", item_text: "TUARAN" },

          { item_id: 62, isActive: "Y", stateCode: "MLK", item_text: "BETONG" },
          { item_id: 63, isActive: "Y", stateCode: "NSB", item_text: "BINTULU" },
          { item_id: 64, isActive: "Y", stateCode: "PRK", item_text: "KAPIT" },
          { item_id: 65, isActive: "Y", stateCode: "PNG", item_text: "KUCHING" },
          { item_id: 66, isActive: "Y", stateCode: "PNGJ", item_text: "LIMBANG" },
          { item_id: 67, isActive: "Y", stateCode: "SBH", item_text: "MIRI" },
          { item_id: 68, isActive: "Y", stateCode: "SWK", item_text: "MUKAH" },
          { item_id: 69, isActive: "Y", stateCode: "SLR", item_text: "SAMARAHAN" },
          { item_id: 70, isActive: "Y", stateCode: "WKL", item_text: "SARIKEI" },
          { item_id: 71, isActive: "Y", stateCode: "WPL", item_text: "SERIAN" },
          { item_id: 72, isActive: "Y", stateCode: "ALL", item_text: "SIBU" },
          { item_id: 73, isActive: "Y", stateCode: "JHR", item_text: "SRI AMAN" },

          { item_id: 74, isActive: "Y", stateCode: "MLK", item_text: "GOMBAK" },
          { item_id: 75, isActive: "Y", stateCode: "NSB", item_text: "HULU LANGAT" },
          { item_id: 76, isActive: "Y", stateCode: "PRK", item_text: "HULU SELANGOR" },
          { item_id: 77, isActive: "Y", stateCode: "PNG", item_text: "KLANG" },
          { item_id: 78, isActive: "Y", stateCode: "PNGJ", item_text: "KUALA LANGAT" },
          { item_id: 79, isActive: "Y", stateCode: "SBH", item_text: "KUALA SELANGOR" },
          { item_id: 80, isActive: "Y", stateCode: "SWK", item_text: "PETALING" },
          { item_id: 81, isActive: "Y", stateCode: "SLR", item_text: "SABAK BERNAM" },
          { item_id: 82, isActive: "Y", stateCode: "WKL", item_text: "SEPANG" },

          { item_id: 83, isActive: "Y", stateCode: "WPL", item_text: "CHERAS" },
          { item_id: 84, isActive: "Y", stateCode: "ALL", item_text: "KEPONG" },
          { item_id: 85, isActive: "Y", stateCode: "JHR", item_text: "LEMBAH PANTAI" },
          { item_id: 86, isActive: "Y", stateCode: "MLK", item_text: "PUTRAJAYA" },
          { item_id: 87, isActive: "Y", stateCode: "NSB", item_text: "TITIWANGSA" },
          { item_id: 88, isActive: "Y", stateCode: "PRK", item_text: "LABUAN" },

        ];
      }

    });
  }


  DateFromHandler() {
    if (this.dateTo != '') {
    } else
      this.date = new Date();

    var day = this.date.getDate();
    var month = this.date.getMonth() + 1;
    var year = this.date.getFullYear();
    var monthStr;
    var dateStr;

    if (month < 10) {
      monthStr = "0" + month
    }
    else {
      monthStr = month
    }
    (day < 10 ? dateStr = "0" + day : dateStr = day);
    this.dateTo = year + "-" + monthStr + "-" + dateStr;
  }

  curDatePicker() {
    let date_ob = new Date();
    let date = ("0" + date_ob.getDate()).slice(-2)
    let month = ("0" + [(date_ob.getMonth() + 1)]).slice(-2);
    let year = date_ob.getFullYear();

    this.curDate = year + "-" + month + "-" + date
  }

  sortByDataKey(dataKey: any, sortDirection: any) {
    this.tableColumns.forEach(col => {
      if (col.dataKey == dataKey) {
        col.sortDirection = sortDirection == '' ? 'asc' : sortDirection == 'asc' ? 'desc' : 'asc'
      } else {
        col.sortDirection = ''
      }
    })
    sortDirection = sortDirection == '' ? 'asc' : sortDirection == 'asc' ? 'desc' : 'asc'
    this.tableDatas.sort(this.dynamicSort(dataKey, sortDirection))
  }

  dynamicSort(property: any, sortDirection: any) {
    var sortOrder = 1;
    if (sortDirection == 'desc') {
      sortOrder = -1;
    }
    return function (a: any, b: any) {
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    }
  }

  resetSortDirection() {
    this.tableColumns.forEach(column => {
      column.sortDirection = ''
    })
  }

  searchData(event: any) {
    this.resetSortDirection()
    if (event.target.value != null) {
      let searchText = event.target.value
      let searchArray = Array.from(this.tableDatasOriginal);
      this.tableDatas = [];
      searchArray.forEach(offerTalent => {
        let stringSearch = JSON.stringify(offerTalent).toLowerCase()
        let q = stringSearch.search(searchText.toLowerCase())
        if (q > -1) {
          this.tableDatas.push(offerTalent)
        }
      });
    } else {
      this.tableDatas = this.tableDatasOriginal
    }
  }

}